import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';
import { spacing } from 'styles/constants';

export const CloseButtonWrapper = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.closeButtonWrapper, style]} />
);

const styles = StyleSheet.create({
  closeButtonWrapper: {
    position: 'absolute',
    right: spacing.$4,
  },
});
